<template>
  <div class="app-container" style="height: 100vh">
    <div class="bdfm_h1">
      <div class="bdfm_form1_div">
        <el-form ref="form" :model="form" label-width="130px" class="bdfm_f1 vertical_center">
          <el-form-item label="标定物条码">
            <el-input v-model="form.code" disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="称入重">
            <el-input v-model="form.weight" disabled>
              <template slot="append">kg</template>
            </el-input>
          </el-form-item>
          <el-form-item label="长">
            <el-input v-model="form.length" disabled>
              <template slot="append">cm</template>
            </el-input>
          </el-form-item>
          <el-form-item label="宽">
            <el-input v-model="form.width" disabled>
              <template slot="append">cm</template>
            </el-input>
          </el-form-item>
          <el-form-item label="高">
            <el-input v-model="form.height" disabled>
              <template slot="append">cm</template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="bdfm_form2_div">
        <span v-if="form.status===''" class="bdfm_status bdfm_normal">核验结果：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <div v-if="form.status===true" class="bdfm_status">
          <span>核验结果：</span>
          <span class="bdfm_pass">通过</span>
        </div>
        <div v-if="form.status===false" class="bdfm_status">
          <span>核验结果：</span>
          <span class="bdfm_failed">异常</span>
        </div>
      </div>
      <div class="bdfm_form3_div">
        <device-items2 :device-list="cameraStateList"></device-items2>
      </div>
    </div>
    <el-row :gutter="10" style="height: 20vh">
      <el-col :span="24" class="vertical_center" style="width: 100%">
        <div class="tip_msg" v-if="this.form.status===false&&!this.form.errormessage">
          <div v-if="weightError">重量偏差±{{ (this.weight_error_threshold * 1000).toFixed(0) }}克，请将秤标定后重新操作！</div>
          <div v-if="volError">单边长度偏差±{{ this.vol_error_threshold }}厘米，请检查标定物后重新操作！</div>
        </div>
        <scan2 v-model="form.input" :errormessage="form.errormessage">
        </scan2>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="height: 40vh">
      <el-col :span="24" class="table-wrapper">
        <el-table
          stripe
          :data="items"
          height="300"
          class="el-custom-table"
          header-cell-class-name="custom-header-cell"
          style="width: 100%;">
          <template v-slot:empty>
            <data-empty></data-empty>
          </template>
          <el-table-column v-for="(item,idx) in tableHeaders"
                           :key="idx"
                           :label="item.label"
                           :prop="item.prop"
                           :width="item.width"
                           align="center"
                           :fixed="item.fixed"
          >
            <template slot-scope="{row}">
              <div v-if="item.prop==='bdfm_status'"
                   :class="{'bdfm_pass':row.bdfm_status,'bdfm_failed':!row.bdfm_status}">
                <span>{{ item.format(row[item.prop]) }}</span>
              </div>
              <div v-else-if="item.prop==='scan_time'" style="font-size: 12pt">
                <span>{{ row[item.prop] }}</span>
              </div>
              <div v-else>
                <span>
                  {{ row[item.prop] }}
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import YtoTable from "../components/YtoTable/TtoTable";
import Scan2 from "../components/Scan/Scan2";
import dayjs from "dayjs";
import DataEmpty from "../components/DataEmpty/DataEmpty";
import {playFailSound, playSuccessSound} from "../../common/voiceTip";
import {SystemConfigModule} from "../../store/modules/store_systemconfig";
import DeviceItems2 from "../components/DeviceStatus/DeviceItems2";
import {errorMsgs} from "../../common/glboalconstant";
import {checkCodesAndType} from "../../api/service";

export default {
  components: {DeviceItems2, DataEmpty, Scan2, YtoTable},
  data() {
    return {
      weight_error_threshold: '0.05',
      vol_error_threshold: '2',
      index: 0,
      form: {
        code: '', weight: '', length: '', width: '', height: '', status: '', errormessage: '', input: ''
      },
      globalConfig: {},
      items: [],
      loginData: {},
      weightError: false,
      volError: false,
      needvol: true,
      tableHeaders: [
        {prop: 'index', label: '序号', width: null},
        {prop: 'bdfm_code', label: '标定物条码', width: 150},
        {prop: 'bdfm_weight', label: '标定物重', width: null},
        {prop: 'bdfm_length', label: '标定物长', width: null},
        {prop: 'bdfm_width', label: '标定物宽', width: null},
        {prop: 'bdfm_height', label: '标定物高', width: null},
        {prop: 'inputWeight', label: '称入重', width: null},
        {prop: 'inputlength', label: '长', width: null},
        {prop: 'inputWidth', label: '宽', width: null},
        {prop: 'inputHeight', label: '高', width: null},
        {
          prop: 'bdfm_status', label: '标定结果', width: null, format: (b) => b ? '通过' : '异常'
        },
        {prop: 'scan_time', label: '扫描时间', width: 220},
        {prop: 'upload_status', label: '状态', width: 120},
        {prop: 'upload_msg', label: '提示警告结果', width: 220},
      ],
      cameraStateList: [],
    }
  },
  mounted() {
    if (typeof obj_bdfm_core !== 'undefined') {
      obj_bdfm_core.registerJavaScriptCallback('receiveServerMsg', this.receiveServerMsg);
      this.globalConfig = SystemConfigModule.globalData;
      this.loginData = SystemConfigModule.loginData;
      this.loadConfig()
      obj_bdfm_core.web_Loaded();
      this.needvol = obj_bdfm_core.getNeedVol();
      console.log('是否校验体积：' + this.needvol)
    }
  },
  methods: {
    loadConfig() {
      try {
        var res = obj_HttpRequest_Core.post('/Yto_MonitorGateway/device/getCalibrateScaleDeviationValue')
        var obj = JSON.parse(res);
        if (obj.respCode === '000') {
          this.vol_error_threshold = obj.data.dimensionDeviation;
          this.weight_error_threshold = obj.data.weightDeviation;
        }
        console.log(res)
      } catch (e) {
        this.vol_error_threshold = 2
        this.weight_error_threshold = 0.05
      }
    },
    receiveServerMsg(msg) {
      var obj = JSON.parse(msg);
      if (obj.DataType === 'CameraState') {
        this.cameraStateList = obj.cameraState.camList;
        return true;
      }
      if (obj.DataType === 'PackageData') {
        debugger
        this.packageData(obj)
        return true;
      }
      if (obj.DataType === 'ErrorState') {
        if (obj.errorCode === '8' || obj.errorCode === '9') {
          this.resetForm();
          return true;
        }
        this.form.errormessage = errorMsgs[Number.parseInt(obj.errorCode)]
      }
      return false;
    },
    packageData(package_data) {
      this.resetForm();
      if (typeof package_data === 'string')
        package_data = JSON.parse(package_data);
      let rgStr = checkCodesAndType([package_data.code])
      let rg = JSON.parse(rgStr);
      if (!package_data.code.startsWith('BDFM') || rg.ResultCode != 200) {
        this.form.errormessage = '非标定物条码，请检查后重新标定！'
        playFailSound()
        return;
      }
      if (package_data.weight < 0) {
        this.form.errormessage = "重量不稳定，读取重量超时";
        playFailSound()
        return false;
      }
      Object.assign(this.form, package_data)
      var data = {
        bdfm_code: package_data.code,
        inputWeight: package_data.weight,
        inputlength: package_data.length,
        inputWidth: package_data.width,
        inputHeight: package_data.height,
        scan_time: dayjs().format("YYYY-MM-DD HH:mm:ss SSS")
      }
      this.index++;
      data.index = this.index;
      data.bdfm_weight = package_data.code.substr(4, 2).replace(/^0+/, '');
      data.bdfm_length = package_data.code.substr(6, 2);
      data.bdfm_width = package_data.code.substr(8, 2);
      data.bdfm_height = package_data.code.substr(10, 2);
      data.calibrationResult = this.errorCheck(data);
      data.bdfm_status = data.calibrationResult === 1;
      this.form.status = data.bdfm_status
      data.upload_status = '未上传'
      data.upload_msg = '未上传'
      data.requestId = package_data.requestId
      this.saveCalibrateScaleRecord(data);
      let len = this.items.unshift(data)
      if (len >= 10) {
        this.items.pop()
      }
    },
    errorCheck(data) {
      let result = 1
      if (Math.abs((data.inputWeight - data.bdfm_weight).toFixed(2)) >= this.weight_error_threshold) {
        this.weightError = true;
      }
      let w1 = [data.inputlength, data.inputWidth, data.inputHeight].sort();
      let w2 = [data.bdfm_length, data.bdfm_width, data.bdfm_height].sort();
      if (this.needvol && Math.abs((w1[0] - w2[0]).toFixed(2)) >= this.vol_error_threshold) {
        this.volError = true;
      }
      if (this.needvol && Math.abs((w1[1] - w2[1]).toFixed(2)) >= this.vol_error_threshold) {
        this.volError = true;
      }
      if (this.needvol && Math.abs((w1[2] - w2[2]).toFixed(2)) >= this.vol_error_threshold) {
        this.volError = true;
      }
      if (this.weightError && this.volError) {
        result = 4;
      }
      if (this.weightError && !this.volError) {
        result = 2;
      }
      if (!this.weightError && this.volError) {
        result = 3;
      }
      if (result === 1) {
        playSuccessSound()
      } else {
        playFailSound()
      }
      return result;
    },
    saveCalibrateScaleRecord(data) {
      var obj = {
        waybillNo: data.bdfm_code,
        calibrationWeight: data.bdfm_weight,
        calibrationLength: data.bdfm_length,
        calibrationWidth: data.bdfm_width,
        calibrationHeight: data.bdfm_height,
        weight: data.inputWeight,
        length: data.inputlength || "",
        width: data.inputWidth || "",
        height: data.inputHeight || "",
        calibrationResult: data.calibrationResult,
        deviceName: this.globalConfig.CompName,
        deviceIp: this.globalConfig.LocalIPv4,
        deviceMac: this.globalConfig.LocalMac,
        optTime: data.scan_time,
        createUserCode: this.loginData.userCode,
        createUserName: this.loginData.userName,
        requestId: data.requestId
      }
      var json = JSON.stringify(obj);
      var res = obj_bdfm_core.saveCalibrateScaleRecord(json);
      var obj = JSON.parse(res)
      if (obj.respcode === '000') {
        data.upload_status = '上传成功'
        data.upload_msg = obj.respMessage
      } else {
        data.upload_status = '上传失败'
        data.upload_msg = obj.respMessage
      }
      console.log(res)
    },
    resetForm() {
      this.weightError = false;
      this.volError = false;
      this.form = {
        code: '', weight: '', length: '', width: '', height: '', status: '', errormessage: '', input: ''
      }
    }
  },
}
</script>

<style scoped lang="less">
/deep/ .el-form-item__label {
  //font-size: 16pt;
}

/deep/ .bdfm_f1 .el-form-item__content .el-input__inner {
  //height: 45px;
  //line-height: 45px;
  //font-size: 20pt;
}

/deep/ .el-table__body .el-table__row .el-table__cell div.cell {
  //font-size: 14pt;
  min-height: 22px;
}

/deep/ .bdfm_f1 input {
  background-color: #EFEFEF;
}

</style>

<style scoped lang="less">
.app-container {
  margin: 10px;
}

.vertical_center {
  position: relative;
  width: 80%;
  top: 50%;
  transform: translateY(-50%);
}

.bdfm_f1 {

}

.bdfm_h1 {
  height: 40vh;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}


.bdfm_form1_div {
  border: 1px @primaryBorderColor solid;
  background-color: @cardBackColor;
  height: 100%;
  width: 100%;
}

.bdfm_form2_div {
  border: 1px @primaryBorderColor solid;
  background-color: @cardBackColor;
  height: 100%;
  width: 100%;
  margin-left: 10px;
}

.bdfm_status {
  font-size: 48pt;
  display: block;
  position: relative;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}

@media screen and (max-width: 1024px) and (min-width: 768px) {
  /*媒体查询是用来设置样式的 当实际的屏幕大小满足条件时就执行样式 */
  .bdfm_status {
    font-size: 40pt;
  }
}

.bdfm_pass {
  color: #81b337;
}

.bdfm_failed {
  color: #ff2525;
}

.tip_msg {
  position: absolute;
  left: 50vw;
  font-size: 18pt;
  color: red;
  font-weight: 600;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.bdfm_form3_div {
  width: 8%;
}

.table-wrapper {
  border: 1px solid @primaryBorderColor;
}
</style>
